import React, {memo} from 'react';
import Alert from '@mui/material/Alert';

import {Badge, Box} from '@mui/material';
import {ReactComponent as NotificationsNoneIcon} from 'images/bell.svg';

import {useTranslation} from 'react-i18next';
import {truncate} from 'lodash';
import TimeLabel from './TimeLabel';
import {useNotifications} from './NotificationContext';
import {NOTIFICATIONS_LENGTH} from 'const';
import {AlertDialog} from 'components/dialogs/AlertDialog';
import Menu from 'components/menu/Menu';
import {useModal} from 'hooks/useModal';

const STATIC_PART_HEIGHT = '3rem';

const NotificationsList = memo(() => {
   const {t} = useTranslation();

   const {notifications: list, markAsRead, clearAll} = useNotifications();

   const {open, handleClose, handleOpen} = useModal();
   const [msg, setMessage] = React.useState('');

   const openToast = React.useCallback((msg: string) => {
      // console.debug(toast);
      setMessage(msg);
      handleOpen();
   }, []);

   return (
      <>
         <Menu
            name={
               <Badge color="primary" badgeContent={list.length}>
                  <NotificationsNoneIcon
                  // color={list.length ? colors.secondary : colors.lightGrey}
                  />
               </Badge>
            }
            disabled={!list.length}
            hideExpandIcon
            classes={{
               paper: 'notifications-list-paper',
            }}
         >
            {list.length ? (
               <>
                  <Box height={STATIC_PART_HEIGHT} position="fixed" width="100%" zIndex={9999}>
                     <Alert
                        severity="warning"
                        variant="filled"
                        onClick={clearAll}
                        sx={{
                           justifyContent: 'center',
                           // background: 'white',
                           width: '100%',
                           cursor: 'pointer',
                        }}
                     >
                        <div style={{textAlign: 'center'}}>{t('Clear all')}</div>
                     </Alert>
                  </Box>
                  <Box height={'3.5rem'} />
               </>
            ) : null}
            {list.map((n) => (
               <Alert
                  severity={n.type}
                  variant="filled"
                  sx={{
                     width: '100%',
                     marginTop: '.4rem',
                     '& .MuiAlert-message': {
                        width: '100%',
                     },
                  }}
                  key={n.id}
                  onClick={() => openToast(n.message)}
                  onClose={(ev) => {
                     ev?.preventDefault();
                     ev?.stopPropagation();
                     markAsRead(n.id);
                  }}
               >
                  <TimeLabel time={n.createdAt} />
                  {truncate(n.message, {length: NOTIFICATIONS_LENGTH})}
               </Alert>
            ))}
         </Menu>
         <AlertDialog open={open} content={msg} onClose={handleClose} />
      </>
   );
});

export default NotificationsList;
